import React from 'react';
import styled from 'styled-components';
import { IconClose } from '../Icons';

const BACKGROUND_COLORS = {
  blue: 'var(--notification-light-blue)',
  red: 'var(--notification-light-red)'
};

const InformationBannerWrapper = styled.div`
  align-items: center;
  background-color: ${(props) => props.$backgroundColor};
  display: flex;
  gap: 10px;
  padding: 10px 20px;
  width: 100%;

  svg {
    flex: 0 0 20px;
    height: 20px;
    width: 20px;
  }
`;

const InformationBannerText = styled.span`
  color: var(--greyscale-blackish);
  flex: 1;
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-small);
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
`;

const InformationBanner = ({ color = 'blue', icon, text, onClose }) => {
  return (
    <InformationBannerWrapper $backgroundColor={BACKGROUND_COLORS[color] || BACKGROUND_COLORS.blue}>
      {icon}
      <InformationBannerText>{text}</InformationBannerText>
      {onClose && (
        <CloseButton type="button" onClick={onClose} aria-label="Hinweis schließen">
          <IconClose />
        </CloseButton>
      )}
    </InformationBannerWrapper>
  );
};

export { InformationBanner };
